import React from 'react';
import moment from 'moment';
import { getToken } from '../utils/authenticator';
import { getHospitalReport } from '../api/hospitalApi';
import { GenerateReportDialog } from 'ui-components';

export default function GenerateHospitalReportDialogContainer(props) {
    const [reportStartDate, setReportStartDate] = React.useState(moment().subtract(2, 'weeks'));
    const [reportEndDate, setReportEndDate] = React.useState(moment());

    const handleReportClose = () => {
        props.handleHospitalReportOpen(false);
    }

    const onSumbitGetReport = async (includePatients) => {
        await getHospitalReport(
            getToken(),
            reportStartDate.format('YYYY-MM-DD'),
            reportEndDate.format('YYYY-MM-DD'),
            props.hospital.id === 'all' ? null : props.hospital.id,
            includePatients === 'yes' ? true : false
        );
        setReportStartDate(moment().subtract(2, 'weeks'));
        setReportEndDate(moment());
        handleReportClose();
    }

    return (
        <GenerateReportDialog 
            open={props.open}
            handleReportClose={handleReportClose}
            reportStartDate={reportStartDate}
            reportEndDate={reportEndDate}
            setReportStartDate={(date)=>{setReportStartDate(date)}}
            setReportEndDate={(date)=>{setReportEndDate(date)}}
            onSumbitGetReport={(includePatients)=>{onSumbitGetReport(includePatients)}}
            helperText={'To generate a report for this hospital, select a date range below:'}
            includeRadioButtons
        />
    )
}